import { INPUT_FIELD_TYPE, INPUT_TYPE } from '@components/DynamicFormField/constant';
export const BBPS_COMPLAINT_FORM_CONFIG = [
  {
    key: 'userId',
    name: 'userId',
    label: 'User ID',
    placeholder: 'Enter User ID',
    fieldType: INPUT_FIELD_TYPE.INPUT,
    inputType: INPUT_TYPE.STRING,
    isEditable: true,
    isRequired: true
  },
  {
    key: 'billId',
    name: 'billId',
    label: 'Bill ID',
    placeholder: 'Enter Bill ID',
    fieldType: INPUT_FIELD_TYPE.INPUT,
    inputType: INPUT_TYPE.STRING,
    isEditable: true,
    isRequired: true
  },
  {
    key: 'orderId',
    name: 'orderId',
    label: 'Order ID',
    placeholder: 'Enter Order ID',
    fieldType: INPUT_FIELD_TYPE.INPUT,
    inputType: INPUT_TYPE.STRING,
    isEditable: true,
    isRequired: true
  },
  {
    key: 'txnId',
    name: 'txnId',
    label: 'Transaction ID',
    placeholder: 'Enter Transaction ID',
    fieldType: INPUT_FIELD_TYPE.INPUT,
    inputType: INPUT_TYPE.STRING,
    isEditable: true,
    isRequired: true
  },
  {
    key: 'disposition',
    name: 'disposition',
    label: 'Complaint Disposition',
    placeholder: 'Select Disposition',
    fieldType: INPUT_FIELD_TYPE.SELECT,
    options: [
      { value: 'WRONG_AMOUNT_DEBITED', label: 'WRONG_AMOUNT_DEBITED' },
      { value: 'AMOUNT_DEBITED_BUT_TRANSACTION_FAILED', label: 'AMOUNT_DEBITED_BUT_TRANSACTION_FAILED' },
      { value: 'AMOUNT_DEBITED_MULTIPLE_TIMES', label: 'AMOUNT_DEBITED_MULTIPLE_TIMES' },
      { value: 'OTHER', label: 'OTHER' }
    ],
    isEditable: true,
    isRequired: true
  },
  {
    key: 'complaintReason',
    name: 'complaintReason',
    label: 'Complaint Reason',
    placeholder: 'Enter complaint reason',
    fieldType: INPUT_FIELD_TYPE.TEXTAREA,
    isEditable: true,
    isRequired: true
  },
  {
    key: 'raisedBy',
    name: 'raisedBy',
    label: 'Raised By',
    placeholder: 'Enter raised by',
    fieldType: INPUT_FIELD_TYPE.INPUT,
    inputType: INPUT_TYPE.STRING,
    isEditable: true,
    isRequired: true
  },
  {
    key: 'notes',
    name: 'notes',
    label: 'Notes',
    placeholder: 'Enter additional notes',
    fieldType: INPUT_FIELD_TYPE.TEXTAREA,
    isEditable: true,
    isRequired: false
  }
];
